<template>
  <div class="site-footer">
    <div class="container">
      
      <div class="row row-info">
        <div class="col-lg-3 img-holder" @click="gotoHome()">
          <img src="../assets/images/logo.png" width="200">
        </div>

        <div class="col-lg-2 pb-4">
          <ul class="list-group">
            <li><a class="footer-link" href="javascript:void()" @click="goto('product-holder')">Soluções</a></li>
            <li><a class="footer-link" target="_blank" href="https://central.bytecom.inf.br">Central de Apoio</a></li>
            <li><a class="footer-link" href="javascript:void()" @click="goto('contacts-holder')">Contato</a></li>
            <li><a class="footer-link" href="javascript:void()">Parceiros</a></li>
            <li><a class="footer-link" href="javascript:void()" @click="goto('contacts-holder')">Trabalhe Conosco</a></li>
            <li><a class="footer-link" href="javascript:void()">Termos de Uso</a></li>
          </ul>
        </div>

        <div class="col-lg-4 pb-4">
          <ul  style="float: left; width: 50%;" class="list-group">
            <li class="pb-4">
              <span class="footer-info">Comercial</span> <br>
              <span class="footer-info"><i class="bi bi-whatsapp"></i> (47) 3370-0735</span> <br>
            </li>
            <li class="pb-4">
              <span class="footer-info">Suporte</span> <br>
              <span class="footer-info"><i class="bi bi-whatsapp"></i> (47) 3370-0735</span> <br>
            </li>
            <li>
              <span class="footer-info">Plantão Suporte</span> <br>
              <span class="footer-info"><i class="bi bi-whatsapp"></i> (47) 3370-0735</span> <br>
            </li>
          </ul>
          <ul  style="width: 50%;" class="list-group">
            <li class="pb-4">
              <span class="footer-info">Financeiro</span> <br>
              <span class="footer-info"><i class="bi bi-whatsapp"></i> (47) 3370-0735</span> <br>
            </li>
            <li>
              <span class="footer-info">Trabalhe Conosco</span> <br>
              <span class="footer-info"><i class="bi bi-whatsapp"></i>  (47) 3370-0735</span> <br>
            </li>
          </ul>
        </div>

        <div class="col-lg-3">
          <ul class="list-group">
            <li>
              <span class="footer-info"><i class="bi bi-geo-alt-fill"></i> 
                Rua João Januário Ayroso, 156 Jaraguá Esquerdo, 89253-100<br>Jaraguá do Sul, SC</span>
            </li>
          </ul>
        </div>
      </div>

      <div class="row text-center copyright">
        <div class="icon-holder">
          <span class="contact-icon">
            <a target="_blank" href="https://www.youtube.com/watch?v=5rgFTMlQQDI&ab_channel=BytecomGroup"><i class="bi bi-youtube"></i></a>
          </span>
          <span class="contact-icon">
            <a target="_blank" href="https://www.instagram.com/bytecomsistemas/"><i class="bi bi-instagram"></i></a>
          </span>
          <span class="contact-icon">
            <a target="_blank" href="https://www.facebook.com/BytecomSistemas"><i class="bi bi-facebook"></i></a>
          </span>
        </div>
        <span class="col-12-lg">Copyright {{ this.getActualYear() }} Bytecom. Todos os direitos reservados.</span>
      </div>

    </div>
  </div>
</template>

<script scoped>

export default {
  name: 'App',
  components: {
  },
  methods: {
    
    getActualYear() {
      var dt = new Date()
      return dt.getFullYear()
    },

    gotoHome() {
      window.location = "/"
    },

    goto(referencia) {
      var el = document.getElementById(referencia)
      window.scrollTo({
        top: el.offsetTop,
        behavior: "smooth",
      });
    }
  }
}
</script>

<style scoped>

.list-group li {
  display: block;
}

.row-info {
  padding: 70px 0 70px 0;
  color: #cecece;
}

.footer-link {
  font-size: 1.1rem;
  color: #cecece;
  text-decoration: none;
  padding-bottom: 2px;
  --bg-h: 2px;
}

.footer-link a {
  background: linear-gradient(0deg, rgb(255, 255, 255), rgb(255, 255, 255)) no-repeat right bottom / 0 var(--bg-h);
  transition: background-size 350ms;
  --bg-h: 100%;
}

.footer-link a:hover {
  color: #cecece;
}

.footer-link a:where(:hover, :focus-visible) {
  background-size: 100% var(--bg-h);
  background-position-x: left;
}


.footer-info {
  font-size: 1rem;
}

.contact-icon a {
  text-decoration: none;
  color: #cecece;
}

.footer-heading {
  font-size: 1.1rem;
  font-weight: 600;
}

.bi-youtube {
  font-size: 24px;
}

.bi-instagram, .bi-facebook {
  font-size: 20px;
}

.contact-icon {
  font-size: 20px;
  margin: 10px;
  cursor: pointer;
}

.copyright {
  color: #cecece;
  font-size: 1rem;
}

.site-footer {
  background-color: #333333;
  font-family: Montserrat Regular;
}

.img-holder {
  cursor: pointer;
}

</style>